<template>
        <el-form ref="feeType6Form" id="feeType6Form"  :model="feeRule" margin-top="0">
                <el-tabs v-model="activeName" @tab-click="handleTabsClick">
                        <el-tab-pane label="工作日高峰" name="first"></el-tab-pane>
                        <el-tab-pane label="工作日非高峰" name="second"></el-tab-pane>
                        <el-tab-pane label="非工作日高峰" name="third"></el-tab-pane>
                        <el-tab-pane label="非工作日非高峰" name="fourth"></el-tab-pane>
                </el-tabs>
                <!-- 高峰時間段一 -->
                <el-row >
                        <el-col span="24" offset="1" style="display: flex;align-items: center;">
                                <el-form-item label-width="0px" required prop="useHighTimeStage1" style="margin-bottom:0px">
                                        <el-checkbox v-model="feeRule.useHighTimeStage1" disabled @change="useStage1Change">
                                                {{(activeName=='first' || activeName=='third')?'高峰':'非高峰'}}时间段1:
                                        </el-checkbox>
                                </el-form-item>
                                <span style="margin:0 10px"></span>
                                <el-select v-model="feeRule.highStartTime1" @change="startTimeChange" :disabled="activeName=='second' || activeName=='fourth'" placeholder="开始时间">
                                        <el-option
                                                v-for="item in workStartTimes"
                                                :key="item.id"
                                                :disabled="item.disabled"
                                                :label="item.time"
                                                :value="item.time">
                                        </el-option>
                                </el-select>
                                <span style="margin:0 10px">至</span>
                                <el-select v-model="feeRule.highEndTime1"
                                @change="changeHighEndTime1"
                                :disabled="activeName=='second' || activeName=='fourth'"
                                placeholder="结束时间">
                                        <el-option
                                                v-for="item in workEndTimes"
                                                :key="item.id"
                                                :disabled="item.disabled"
                                                :label="item.time"
                                                :value="item.time">
                                        </el-option>
                                </el-select>
                        </el-col>
                </el-row>
                <!-- 高峰時間段二 -->
                <el-row style="margin:20px 0;">
                        <el-col span="24" offset="1" style="display: flex;align-items: center;">
                                <el-form-item label-width="0px"  prop="" style="margin-bottom:0px">
                                        <el-checkbox v-model="feeRule.useHighTimeStage2" :disabled="activeName=='second' || activeName=='fourth'"  @change="selectUseHighTimeStage2">
                                                {{(activeName=='first' || activeName=='third')?'高峰':'非高峰'}}时间段2:
                                        </el-checkbox>
                                </el-form-item>

                                <span style="margin:0 10px"></span>
                                <el-select v-model="feeRule.highStartTime2" :disabled="!feeRule.useHighTimeStage2 || (activeName=='second' || activeName=='fourth')" @change="changeHighStartTime2" placeholder="开始时间">
                                        <el-option
                                                v-for="item in workStartTimes2"
                                                :key="item.id"
                                                :disabled="item.disabled"
                                                :label="item.time"
                                                :value="item.time">
                                        </el-option>
                                </el-select>
                                <span style="margin:0 10px">至</span>
                                <el-select v-model="feeRule.highEndTime2" @change="changeHighEndTime2" :disabled="!feeRule.useHighTimeStage2 || (activeName=='second' || activeName=='fourth')" placeholder="结束时间">
                                        <el-option
                                                v-for="item in workEndTimes2"
                                                :key="item.id"
                                                :disabled="item.disabled"
                                                :label="item.time"
                                                :value="item.time">
                                        </el-option>
                                </el-select>
                        </el-col>
                </el-row>
                <el-row>
                        <el-col span="24" v-if="activeName=='first'">
                                <el-form-item label="工作日高峰时段收费限额" label-width="200px" :rules="moneyRules" required  prop="workDayHighTimeFeeLimit">
                                        <el-input v-model="feeRule.workDayHighTimeFeeLimit" placeholder="请输入收费限额"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col span="24"  v-if="activeName=='second'">
                                <el-form-item label="工作日非高峰时段收费限额" label-width="200px" :rules="moneyRules" required  prop="workDayNoHighTimeFeeLimit">
                                        <el-input v-model="feeRule.workDayNoHighTimeFeeLimit" placeholder="请输入收费限额"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col span="24"  v-if="activeName=='third'">
                                <el-form-item label="非工作日高峰时段收费限额" label-width="200px" :rules="moneyRules" required  prop="noWorkDayHighTimeFeeLimit">
                                        <el-input v-model="feeRule.noWorkDayHighTimeFeeLimit" placeholder="请输入收费限额"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col span="24"  v-if="activeName=='fourth'">
                                <el-form-item label="非工作日非高峰时段收费限额" label-width="210px" :rules="moneyRules" required  prop="noWorkDayNoHighTimeFeeLimit">
                                        <el-input v-model="feeRule.noWorkDayNoHighTimeFeeLimit" placeholder="请输入收费限额"></el-input>
                                </el-form-item>
                        </el-col>
                </el-row>
                <!-- 按停車時間收費 -->
                <el-row>
                        <el-col :span="24">
                                <el-radio v-model="feeRule.feeType"  @change="checkFeeByParkingTime(1)"  :label="1">按停车时间收费</el-radio>
                        </el-col>
                </el-row>
                <!-- 階段一 -->
                <el-row>
                        <el-col :span="2" offset="1">
                                <el-form-item label-width="0px" prop="useStage1">
                                        <el-checkbox v-model="feeRule.useTimeStage1" disabled="true">
                                                阶段一:
                                        </el-checkbox>
                                </el-form-item>
                        </el-col>
                        <el-col :span="2">
                                <el-form-item label=" " prop="timeStage1Time1" label-width="15px" :rules="feeRule.useTimeStage1 && feeRule.feeType === 1?freeTimeRules:[]">
                                        <el-input type="number" v-model="feeRule.timeStage1Time1" :disabled="!feeRule.useTimeStage1 || feeRule.feeType==2"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col :span="6">
                                <el-form-item label="小时内收费" prop="timeStage1Fee1" label-width="100px" :rules="feeRule.useTimeStage1 && feeRule.feeType === 1?moneyRules:[]">
                                <el-input type="number" v-model="feeRule.timeStage1Fee1" :disabled="!feeRule.useTimeStage1 || feeRule.feeType==2"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col :span="6">
                                <el-form-item label="元，之后每" prop="timeStage1Time2" label-width="100px" :rules="feeRule.useTimeStage1 && feeRule.feeType === 1?minuteTimeRule:[]">
                                <el-input type="number" v-model="feeRule.timeStage1Time2" :disabled="!feeRule.useTimeStage1 || feeRule.feeType==2"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col :span="6">
                                <el-form-item label="小时，收费" prop="timeStage1Fee2" label-width="100px" :rules="feeRule.useTimeStage1 && feeRule.feeType === 1?moneyRules:[]">
                                <el-input type="number" v-model="feeRule.timeStage1Fee2" :disabled="!feeRule.useTimeStage1 || feeRule.feeType==2"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col :span="1">
                                <el-form-item label="元" label-width="30px"/>

                        </el-col>
                </el-row>
                <!-- 階段二 -->
                <el-row>
                        <el-col :span="2" offset="1">
                                <el-form-item label-width="0px" prop="useTimeStage2">
                                        <el-checkbox v-model="feeRule.useTimeStage2" :disabled="!feeRule.useTimeStage1 || feeRule.feeType==2" @change="useStage2Change">阶段二:
                                        </el-checkbox>
                                </el-form-item>
                        </el-col>
                        <el-col :span="2">
                                <el-form-item label=" " prop="timeStage2Time1" label-width="15px" :rules="feeRule.useTimeStage2 && feeRule.feeType === 1?freeTimeRules:[]">
                                        <el-input type="number" v-model="feeRule.timeStage2Time1" :disabled="!feeRule.useTimeStage2 || feeRule.feeType==2"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col :span="6">
                                <el-form-item label="小时后，每" prop="timeStage2Time2" label-width="100px" :rules="feeRule.useTimeStage2 && feeRule.feeType === 1?minuteTimeRule:[]">
                                        <el-input type="number" v-model="feeRule.timeStage2Time2" :disabled="!feeRule.useTimeStage2 || feeRule.feeType==2"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col :span="6">
                                <el-form-item label="小时，收费" prop="timeStage2Fee1" label-width="100px" :rules="feeRule.useTimeStage2 && feeRule.feeType === 1?moneyRules:[]">
                                        <el-input type="number" v-model="feeRule.timeStage2Fee1" :disabled="!feeRule.useTimeStage2 || feeRule.feeType==2"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col :span="1">
                                <el-form-item label="元" label-width="30px"/>
                        </el-col>
                </el-row>
                <!-- 階段三 -->
                <el-row>
                        <el-col :span="1" offset="1">
                                <el-form-item label-width="0px" prop="useTimeStage3">
                                        <el-checkbox v-model="feeRule.useTimeStage3" :disabled="feeRule.feeType==2"
                                                @change="useStage4Change"></el-checkbox>
                                </el-form-item>
                        </el-col>
                        <el-col :span="3">
                                <el-form-item label=" " prop="timeStage3Time1" label-width="15px" :rules="feeRule.useTimeStage3  && feeRule.feeType === 1?freeTimeRules:[]">
                                        <el-input type="number" v-model="feeRule.timeStage3Time1" :disabled="!feeRule.useTimeStage3 || feeRule.feeType==2"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col :span="6">
                                <el-form-item label="小时之后，加收" prop="timeStage3Fee1" label-width="130px" :rules="feeRule.useTimeStage3 && feeRule.feeType === 1?moneyRules:[]">
                                        <el-input type="number" v-model="feeRule.timeStage3Fee1" :disabled="!feeRule.useTimeStage3 || feeRule.feeType==2"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col :span="1">
                                <el-form-item label="元" label-width="30px">
                                </el-form-item>
                        </el-col>
                </el-row>
                <!-- 按次收費 -->
                <el-row>
                        <el-col :span="24">
                                <el-radio v-model="feeRule.feeType" @change="checkFeeByParkingTime(2)"  :label="2">按次数收费</el-radio>
                        </el-col>
                </el-row>
                <!-- 階段一 -->
                <el-row>
                        <el-col :span="1" offset="1">
                                <el-form-item label-width="0px" prop="useCountStage1">
                                        <el-checkbox v-model="feeRule.useCountStage1" disabled="true" @change="useTimes1Change"></el-checkbox>
                                </el-form-item>
                        </el-col>
                        <el-col :span="2">
                                <el-form-item label="" prop="countStage1Time1" label-width="1px" :rules="feeRule.useCountStage1 && feeRule.feeType === 2?minuteTimeRule:[]">
                                        <el-input type="number" v-model="feeRule.countStage1Time1" :disabled="!feeRule.useCountStage1"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col :span="7">
                                <el-form-item label="分钟内，每次收费" prop="countStage1Fee1" label-width="150px" :rules="feeRule.useCountStage1 && feeRule.feeType === 2?moneyRules:[]">
                                        <el-input type="number" v-model="feeRule.countStage1Fee1" :disabled="!feeRule.useCountStage1"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col :span="6">
                                <el-form-item label="元，超过后每次收费" prop="countStage1Fee2" label-width="150px" :rules="feeRule.useCountStage1 && feeRule.feeType === 2?moneyRules:[]">
                                        <el-input type="number" v-model="feeRule.countStage1Fee2" :disabled="!feeRule.useCountStage1"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col :span="1">
                                <el-form-item label="元" label-width="30px">
                                </el-form-item>
                        </el-col>
                </el-row>
                <!-- 階段二 -->
                <el-row>
                        <el-col :span="1" offset="1">
                                <el-form-item label-width="0px" prop="useTimes2">
                                        <el-checkbox v-model="feeRule.useCountStage2" :disabled="!feeRule.useCountStage1"
                                                        @change="useTimes2Change"></el-checkbox>
                                </el-form-item>
                        </el-col>
                        <el-col :span="3">
                                <el-form-item label="" prop="countStage2Time1" label-width="1px" :rules="feeRule.useCountStage2 && feeRule.feeType === 2?freeTimeRules:[]">
                                        <el-input type="number" v-model="feeRule.countStage2Time1" :disabled="!feeRule.useCountStage2"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col :span="6">
                                <el-form-item label="分钟之后，加收" prop="countStage2Fee1" label-width="150px" :rules="feeRule.useCountStage2 && feeRule.feeType === 2?moneyRules:[]">
                                        <el-input type="number" v-model="feeRule.countStage2Fee1" :disabled="!feeRule.useCountStage2"></el-input>
                                </el-form-item>
                        </el-col>
                        <el-col :span="1">
                                <el-form-item label="元" label-width="30px">
                                </el-form-item>
                        </el-col>
                </el-row>
        </el-form>
</template>
<script>
export default {
        data(){
                 var moneyCheck = (rule, value, callback) => {
                        if ((typeof value !== 'number' && isNaN(value)) || value < 0 || value > 999999) {
                        callback(new Error('有效金额[0-999999]!'));
                        } else {
                        var stringValue = value + '';
                        var valueArray = stringValue.split('.');
                        if (stringValue.startsWith('0') && !stringValue.startsWith('0.') && stringValue.length > 1) {
                        callback(new Error('有效金额[0-999999]!'));
                        } else if (valueArray.length === 2 && valueArray[1].length > 2) {
                        callback(new Error('最多2位有效数字!'));
                        } else {
                        callback();
                        }
                        //else if((valueArray.length === 2 && valueArray[1].length>2) || )
                        }
                };
                var freeTimeCheck = (rule, value, callback) => {
                        if ((typeof value !== 'number' && isNaN(value)) || value < 0 ) {
                                callback(new Error('请输入有效数字！'));
                        } else {
                                if(Number(value)>99999){
                                        callback(new Error('请输入不大于99999数字！'));
                                }else{
                                        var stringValue = value + '';
                                        stringValue = stringValue.slice(0,9)
                                        var valueArray = stringValue.split('.');
                                        if (stringValue.startsWith('0') || valueArray.length > 1) {
                                                callback(new Error('请输入正整数!'));
                                        } else {
                                                callback();
                                        }
                                }

                        }
                };
                return{
                        activeName:'first',
                        feeRule:{},
                        feeRule1:{
                                activeName:'first',
                                highStartTime1:'',
                                highEndTime1:'',
                                highStartTime2:'',
                                highEndTime2:'',

                                useHighTimeStage1:true,
                                useHighTimeStage2:false,
                                workDayHighTimeFeeLimit:'',
                                workDayNoHighTimeFeeLimit:'',
                                noWorkDayHighTimeFeeLimit:'',
                                noWorkDayNoHighTimeFeeLimit:'',

                                feeType:1,
                                useTimeStage1:true,                     //是否启用阶段一收费
                                timeStage1Time1:'',                     //阶段1收费时 停车时长1
                                timeStage1Fee1:'',                      //阶段1收费时 停车时长1时收费金额
                                timeStage1Time2:'',                     //阶段1收费时 超过停车时长1后 每过多少小时时间
                                timeStage1Fee2:'',                      //阶段1收费时 超过停车时长1后 每过多少小时时间收费多少钱
                                useTimeStage2:false,                    //是否启用阶段二收费
                                timeStage2Time1:'',                     //阶段二启用时，过多少小时后开始达到启用阶段二
                                timeStage2Time2:'',                     //达到启用阶段二后 每过多少小时时间
                                timeStage2Fee1:'',                      //达到启用阶段二后 每过多少小时时间收费多少钱
                                useTimeStage3:false,                    //是否启用阶段三收费
                                timeStage3Time1:'',                     //阶段三启用时，过多少小时后开始达到启用阶段三
                                timeStage3Fee1:'',                      //达到启用阶段三后额外增收多长时间

                                useCountStage1:false,                   //是否启用次数收费阶段1
                                countStage1Time1:'',                    //次数阶段1收费时 停车时长1
                                countStage1Fee1:'',                     //阶段1收费金额
                                countStage1Fee2:'',                     //超过停车时长1的收费金额
                                useCountStage2:false,                   //
                                countStage2Time1:'',                    //
                                countStage2Fee1:'',                     //


                        },
                        feeRule2:{
                                activeName:'second',
                                highStartTime1:'',
                                highEndTime1:'',
                                highStartTime2:'',
                                highEndTime2:'',

                                useHighTimeStage1:true,
                                useHighTimeStage2:false,
                                workDayHighTimeFeeLimit:'',
                                workDayNoHighTimeFeeLimit:'',
                                noWorkDayHighTimeFeeLimit:'',
                                noWorkDayNoHighTimeFeeLimit:'',

                                feeType:1,
                                useTimeStage1:true,                     //是否启用阶段一收费
                                timeStage1Time1:'',                     //阶段1收费时 停车时长1
                                timeStage1Fee1:'',                      //阶段1收费时 停车时长1时收费金额
                                timeStage1Time2:'',                     //阶段1收费时 超过停车时长1后 每过多少小时时间
                                timeStage1Fee2:'',                      //阶段1收费时 超过停车时长1后 每过多少小时时间收费多少钱
                                useTimeStage2:false,                    //是否启用阶段二收费
                                timeStage2Time1:'',                     //阶段二启用时，过多少小时后开始达到启用阶段二
                                timeStage2Time2:'',                     //达到启用阶段二后 每过多少小时时间
                                timeStage2Fee1:'',                      //达到启用阶段二后 每过多少小时时间收费多少钱
                                useTimeStage3:false,                    //是否启用阶段三收费
                                timeStage3Time1:'',                     //阶段三启用时，过多少小时后开始达到启用阶段三
                                timeStage3Fee1:'',                      //达到启用阶段三后额外增收多长时间

                                useCountStage1:false,                   //是否启用次数收费阶段1
                                countStage1Time1:'',                    //次数阶段1收费时 停车时长1
                                countStage1Fee1:'',                     //阶段1收费金额
                                countStage1Fee2:'',                     //超过停车时长1的收费金额
                                useCountStage2:false,                   //
                                countStage2Time1:'',                    //
                                countStage2Fee1:'',                     //


                        },
                        feeRule3:{
                                activeName:'third',
                                highStartTime1:'',
                                highEndTime1:'',
                                highStartTime2:'',
                                highEndTime2:'',

                                useHighTimeStage1:true,
                                useHighTimeStage2:false,
                                workDayHighTimeFeeLimit:'',
                                workDayNoHighTimeFeeLimit:'',
                                noWorkDayHighTimeFeeLimit:'',
                                noWorkDayNoHighTimeFeeLimit:'',

                                feeType:1,
                                useTimeStage1:true,                     //是否启用阶段一收费
                                timeStage1Time1:'',                     //阶段1收费时 停车时长1
                                timeStage1Fee1:'',                      //阶段1收费时 停车时长1时收费金额
                                timeStage1Time2:'',                     //阶段1收费时 超过停车时长1后 每过多少小时时间
                                timeStage1Fee2:'',                      //阶段1收费时 超过停车时长1后 每过多少小时时间收费多少钱
                                useTimeStage2:false,                    //是否启用阶段二收费
                                timeStage2Time1:'',                     //阶段二启用时，过多少小时后开始达到启用阶段二
                                timeStage2Time2:'',                     //达到启用阶段二后 每过多少小时时间
                                timeStage2Fee1:'',                      //达到启用阶段二后 每过多少小时时间收费多少钱
                                useTimeStage3:false,                    //是否启用阶段三收费
                                timeStage3Time1:'',                     //阶段三启用时，过多少小时后开始达到启用阶段三
                                timeStage3Fee1:'',                      //达到启用阶段三后额外增收多长时间

                                useCountStage1:false,                   //是否启用次数收费阶段1
                                countStage1Time1:'',                    //次数阶段1收费时 停车时长1
                                countStage1Fee1:'',                     //阶段1收费金额
                                countStage1Fee2:'',                     //超过停车时长1的收费金额
                                useCountStage2:false,                   //
                                countStage2Time1:'',                    //
                                countStage2Fee1:'',                     //


                        },
                        feeRule4:{
                                activeName:'fourth',
                                highStartTime1:'',
                                highEndTime1:'',
                                highStartTime2:'',
                                highEndTime2:'',

                                useHighTimeStage1:true,
                                useHighTimeStage2:false,
                                workDayHighTimeFeeLimit:'',
                                workDayNoHighTimeFeeLimit:'',
                                noWorkDayHighTimeFeeLimit:'',
                                noWorkDayNoHighTimeFeeLimit:'',

                                feeType:1,
                                useTimeStage1:true,                     //是否启用阶段一收费
                                timeStage1Time1:'',                     //阶段1收费时 停车时长1
                                timeStage1Fee1:'',                      //阶段1收费时 停车时长1时收费金额
                                timeStage1Time2:'',                     //阶段1收费时 超过停车时长1后 每过多少小时时间
                                timeStage1Fee2:'',                      //阶段1收费时 超过停车时长1后 每过多少小时时间收费多少钱
                                useTimeStage2:false,                    //是否启用阶段二收费
                                timeStage2Time1:'',                     //阶段二启用时，过多少小时后开始达到启用阶段二
                                timeStage2Time2:'',                     //达到启用阶段二后 每过多少小时时间
                                timeStage2Fee1:'',                      //达到启用阶段二后 每过多少小时时间收费多少钱
                                useTimeStage3:false,                    //是否启用阶段三收费
                                timeStage3Time1:'',                     //阶段三启用时，过多少小时后开始达到启用阶段三
                                timeStage3Fee1:'',                      //达到启用阶段三后额外增收多长时间

                                useCountStage1:false,                   //是否启用次数收费阶段1
                                countStage1Time1:'',                    //次数阶段1收费时 停车时长1
                                countStage1Fee1:'',                     //阶段1收费金额
                                countStage1Fee2:'',                     //超过停车时长1的收费金额
                                useCountStage2:false,                   //
                                countStage2Time1:'',                    //
                                countStage2Fee1:'',                     //


                        },
                        useHighTimeStage2:{
                                highStartTime2:'',
                                highEndTime2:'',
                        },
                        workStartTimes:[],
                        workEndTimes:[],
                        workStartTimes2:[],
                        workEndTimes2:[],
                        moneyRules: [
                                {required: true, message: '请输入收费金额', trigger: 'blur'},
                                {required: true, message: '请输入收费金额', trigger: 'change'},
                                {validator: moneyCheck, trigger: 'blur'},
                        ],
                        freeTimeRules: [
                                {required: true, message: '请输入免费时长', trigger: 'blur'},
                                {validator: freeTimeCheck, trigger: 'blur'},
                        ],
                        minuteTimeRule: [
                                {required: true, message: '请输入数字', trigger: 'blur'},
                                {validator: freeTimeCheck, trigger: 'blur'},
                        ],
                        timeRule: [
                                {required: true, message: '请选择时间', trigger: 'blur'},
                        ],

                }
        },
        created(){
                this.initTime();
                this.initData();

        },
        watch:{
                'feeRule'(){
                        this.getTimesSelectData();
                }
        },
        methods:{
                // 动态加载时间选择下拉框数据
                getTimesSelectData(){
                        let highStartTime1Id = 0;
                        let highEndTime1Id = 0;
                        let highStartTime2Id = 0;
                        // 高峰时间段一 开始时间下拉框 不用动
                        // 高峰时间段一 结束时间下拉框 根据高峰时间段一 开始时间 获得
                        if(this.feeRule.highStartTime1){
                                let workEndTimes = [];
                                this.workStartTimes.forEach(ele=>{
                                        if(ele.time ==  this.feeRule.highStartTime1){
                                                highStartTime1Id = ele.id;
                                        }
                                })
                                this.workStartTimes.forEach((ele,index)=>{
                                        if( highStartTime1Id < ele.id){
                                                workEndTimes.push({
                                                        id:ele.id,
                                                        time:ele.time,
                                                        disabled:false,
                                                })
                                        }

                                })
                                this.workEndTimes = workEndTimes;
                        }else{
                                this.workEndTimes = [];
                        }
                        // 高峰时间段2 开始时间根据高峰时间段开始和结束时间获得
                        if(this.feeRule.useHighTimeStage2){

                                let workStartTimes2 = [];
                                let workEndTimes2 = []
                                this.workStartTimes.forEach(ele=>{
                                        if(ele.time ==  this.feeRule.highStartTime1){
                                                highStartTime1Id = ele.id;
                                        }
                                        if(ele.time ==  this.feeRule.highEndTime1){
                                                highEndTime1Id = ele.id;
                                        }
                                        if(ele.time ==  this.feeRule.highStartTime2){
                                                highStartTime2Id = ele.id;
                                        }
                                })
                                this.workStartTimes.forEach(ele=>{
                                        if(highStartTime1Id > ele.id  ||  ele.id >= highEndTime1Id){
                                                         workStartTimes2.push({
                                                                id:ele.id,
                                                                time:ele.time,
                                                                disabled:false,
                                                        })
                                        }

                                })
                                this.workStartTimes2 = workStartTimes2;
                                // 高峰时间段2 结束时间根据前三者获得
                                if(highStartTime2Id < highStartTime1Id){
                                        this.workStartTimes.forEach(ele=>{
                                                if(highStartTime2Id < ele.id  &&  ele.id <= highStartTime1Id){
                                                        workEndTimes2.push({
                                                                id:ele.id,
                                                                time:ele.time,
                                                                disabled:false,
                                                        })

                                                }
                                        })
                                }else{
                                        this.workStartTimes.forEach(ele=>{
                                                if(highStartTime2Id < ele.id){
                                                        workEndTimes2.push({
                                                                id:ele.id,
                                                                time:ele.time,
                                                                disabled:false,
                                                        })

                                                }
                                        })
                                }
                                this.workEndTimes2 = workEndTimes2;
                        }


                },
                // 数据初始化
                initData(data){
                        if(data){
                                this.feeRule1 = data.weekendDayWorkHighFeeRuleDTO;
                                this.feeRule1.activeName = "first";

                                this.feeRule2 = Object.assign(data.weekendDayWorkNoHighFeeRuleDTO,{
                                        highStartTime1:data.weekendDayWorkNoHighFeeRuleDTO.noHighStartTime1,
                                        highEndTime1:data.weekendDayWorkNoHighFeeRuleDTO.noHighEndTime1,
                                        highStartTime2:data.weekendDayWorkNoHighFeeRuleDTO.noHighStartTime2,
                                        highEndTime2:data.weekendDayWorkNoHighFeeRuleDTO.noHighEndTime2,
                                });
                                this.feeRule2.activeName = "second";

                                this.feeRule3 = data.weekendDayNoWorkHighFeeRuleDTO;
                                this.feeRule3.activeName = "third";

                                this.feeRule4 = Object.assign(data.weekendDayNoWorkNoHighFeeRuleDTO,{
                                        highStartTime1:data.weekendDayNoWorkNoHighFeeRuleDTO.noHighStartTime1,
                                        highEndTime1:data.weekendDayNoWorkNoHighFeeRuleDTO.noHighEndTime1,
                                        highStartTime2:data.weekendDayNoWorkNoHighFeeRuleDTO.noHighStartTime2,
                                        highEndTime2:data.weekendDayNoWorkNoHighFeeRuleDTO.noHighEndTime2,
                                });
                                this.feeRule4.activeName = "fourth";
                        }

                        this.feeRule = this.feeRule1;

                },
                // 封装各个页签得数据，最后在提交方法里面生成一个完整得数据
                publicProperty(feeRule,isPeak){
                        return {
                                feeType:feeRule.feeType,
                                useTimeStage1:true,
                                timeStage1Time1:feeRule.timeStage1Time1,
                                timeStage1Fee1:feeRule.timeStage1Fee1,
                                timeStage1Time2:feeRule.timeStage1Time2,
                                timeStage1Fee2:feeRule.timeStage1Fee2,
                                useTimeStage2:feeRule.useTimeStage2,
                                timeStage2Time1:feeRule.timeStage2Time1,
                                timeStage2Time2:feeRule.timeStage2Time2,
                                timeStage2Fee1:feeRule.timeStage2Fee1,
                                useTimeStage3:feeRule.useTimeStage3,
                                timeStage3Time1:feeRule.timeStage3Time1,
                                timeStage3Fee1:feeRule.timeStage3Fee1,
                                useCountStage1:feeRule.useCountStage1,
                                countStage1Time1:feeRule.countStage1Time1,
                                countStage1Fee1:feeRule.countStage1Fee1,
                                countStage1Fee2:feeRule.countStage1Fee2,
                                useCountStage2:feeRule.useCountStage2,
                                countStage2Time1:feeRule.countStage2Time1,
                                countStage2Fee1:feeRule.countStage2Fee1,
                                useHighTimeStage1:true,
                                useHighTimeStage2:feeRule.useHighTimeStage2,
                                ...(()=>{
                                        if(isPeak){
                                                return{
                                                        highStartTime1:feeRule.highStartTime1,
                                                        highEndTime1:feeRule.highEndTime1,
                                                        highStartTime2:feeRule.highStartTime2,
                                                        highEndTime2:feeRule.highEndTime2,
                                                }
                                        }else{
                                                return{
                                                        noHighStartTime1:feeRule.highStartTime1,
                                                        noHighEndTime1:feeRule.highEndTime1,
                                                        noHighStartTime2:feeRule.highStartTime2,
                                                        noHighEndTime2:feeRule.highEndTime2,
                                                }
                                        }

                                })(),

                        }
                },
                // 提交验证 返回表单数据
                getFormData(callback){
                        if(!this.feeRule.highStartTime1 || !this.feeRule.highEndTime1){
                                this.$message({
                                        message: '请先设置完【高峰时间段1】再保存!',
                                        type: 'warning'
                                });
                                callback({valid:false,formData:{}})
                                return {valid:false,formData:{}};
                        }
                        if(this.feeRule.useHighTimeStage2 && (!this.feeRule.highStartTime2 || !this.feeRule.highStartTime2)){
                                this.$message({
                                        message: '请先设置完【高峰时间段2】再保存!',
                                        type: 'warning'
                                });
                                callback({valid:false,formData:{}})
                                return {valid:false,formData:{}};
                        }
                        this.$refs.feeType6Form.validate((valid) => {

                                if (valid) {

                                        let feeRule = {};
                                        // 工作日高峰
                                        feeRule.weekendDayWorkHighFeeRuleDTO = {

                                                workDayHighTimeFeeLimit:this.feeRule1.workDayHighTimeFeeLimit,
                                                ...this.publicProperty(this.feeRule1,true)
                                        }

                                        // 工作日非高峰
                                        feeRule.weekendDayWorkNoHighFeeRuleDTO = {

                                                workDayNoHighTimeFeeLimit:this.feeRule2.workDayNoHighTimeFeeLimit,
                                                ...this.publicProperty(this.feeRule2,false)
                                        }

                                        // 非工作日高峰
                                        feeRule.weekendDayNoWorkHighFeeRuleDTO = {

                                                noWorkDayHighTimeFeeLimit:this.feeRule3.noWorkDayHighTimeFeeLimit,
                                                ...this.publicProperty(this.feeRule3,true)
                                        }

                                        // 非工作日非高峰
                                        feeRule.weekendDayNoWorkNoHighFeeRuleDTO = {

                                                noWorkDayNoHighTimeFeeLimit:this.feeRule4.noWorkDayNoHighTimeFeeLimit,
                                                ...this.publicProperty(this.feeRule4,false)
                                        }
                                        let formData = JSON.stringify(feeRule)

                                        callback({valid:true,formData:formData})

                                } else {
                                        callback({valid:false,formData:{}})
                                        return false;
                                }
                        });
                },
                // 高峰时间段一开始时间变化
                startTimeChange(e){
                        let workEndTimes = [];
                        let time = null;
                        this.workStartTimes.forEach((ele,index)=>{
                                if(ele.time == e){
                                        time = ele;
                                }

                                if(ele.time != e && (!time || time.id > index)){
                                        // workEndTimes.push({
                                        //         id:ele.id,
                                        //         time:ele.time,
                                        //         disabled:true,
                                        // })
                                }else if( index == time.id){
                                        // workEndTimes.push({
                                        //         id:ele.id,
                                        //         time:ele.time,
                                        //         disabled:true,
                                        // })
                                }else{
                                        workEndTimes.push({
                                                id:ele.id,
                                                time:ele.time,
                                                disabled:false,
                                        })
                                }
                        })
                        this.feeRule.highEndTime1 = "";
                        this.workEndTimes = workEndTimes;
                        this.feeRule.useHighTimeStage2 = false;
                        this.feeRule.highStartTime2 = '';
                        this.feeRule.highEndTime2 = '';
                },
                // 高峰时间段一 结束时间变化
                changeHighEndTime1(e){
                        this.feeRule.useHighTimeStage2 = false;
                        this.feeRule.highStartTime2 = '';
                        this.feeRule.highEndTime2 = '';
                        if(this.activeName == 'first'){
                                this.feeRule2.highStartTime1 = e;
                                this.feeRule2.highEndTime1 = this.feeRule.highStartTime1;
                                this.feeRule2.useHighTimeStage2 = false;
                                this.feeRule2.highStartTime2 = '';
                                this.feeRule2.highEndTime2 = '';
                        }
                        if(this.activeName == 'third'){
                                this.feeRule4.highStartTime1 = this.feeRule.highEndTime1;
                                this.feeRule4.highEndTime1 = this.feeRule.highStartTime1;
                                this.feeRule4.useHighTimeStage2 = false;
                                this.feeRule4.highStartTime2 = '';
                                this.feeRule4.highEndTime2 = '';
                        }
                },
                // 计算非高峰时间
                showNoPeakTime(value,key,clear){
                        if(clear){
                                if(this.activeName == 'first'){
                                        this.feeRule2.highStartTime2 = '';
                                        this.feeRule2.highEndTime2 = '';
                                        this.feeRule2.useHighTimeStage2 = false;
                                }
                                if(this.activeName == 'third'){
                                        this.feeRule4.highStartTime2 = '';
                                        this.feeRule4.highEndTime2 = '';
                                        this.feeRule4.useHighTimeStage2 = false;
                                }
                        }

                        if(this.activeName == 'first'){
                                this.feeRule2[key] = value;
                        }
                        if(this.activeName == 'third'){
                                this.feeRule4[key] = value;
                        }

                },
                // 高峰时间段二 结束时间变化
                changeHighEndTime2(e){
                        let highEndTime1Id = 0;
                        let highStartTime1Id = 0;
                        let highStartTime2Id = 0;
                        let highEndTime2Id = 0;
                        this.workStartTimes.forEach(ele=>{
                                if(ele.time==this.feeRule.highStartTime1){
                                        highStartTime1Id = ele.id;
                                }
                                if(ele.time==this.feeRule.highEndTime1){
                                        highEndTime1Id = ele.id;
                                }
                                if(ele.time==this.feeRule.highStartTime2){
                                        highStartTime2Id = ele.id;
                                }
                                if(ele.time==this.feeRule.highEndTime2){
                                        highEndTime2Id = ele.id;
                                }
                        })
                        // 时间段二 在时间段一之前
                        if(highStartTime2Id < highStartTime1Id){
                                // 时间段一和时间段二是否是连续得
                                if(highEndTime2Id == highStartTime1Id){
                                        this.showNoPeakTime(this.feeRule.highStartTime2,'highEndTime1');
                                        this.showNoPeakTime(this.feeRule.highEndTime1,'highStartTime1',true);
                                }else if(highStartTime2Id===0 && highEndTime1Id === 48){

                                        this.showNoPeakTime(this.feeRule.highEndTime2,'highStartTime1');
                                        this.showNoPeakTime(this.feeRule.highStartTime1,'highEndTime1',true);
                                }else{
                                        this.showNoPeakTime(this.feeRule.highEndTime2,'highStartTime1');
                                        this.showNoPeakTime(this.feeRule.highStartTime1,'highEndTime1');
                                        this.showNoPeakTime(this.feeRule.highEndTime1,'highStartTime2');
                                        this.showNoPeakTime(this.feeRule.highStartTime2,'highEndTime2');
                                        if(this.activeName == 'first'){
                                                this.feeRule2.useHighTimeStage2 = true;
                                        }
                                        if(this.activeName == 'third'){
                                                this.feeRule4.useHighTimeStage2 = true;
                                        }

                                }
                        }else{
                                // 时间段一和时间段二是否是连续得
                                if(highEndTime1Id == highStartTime2Id ){
                                        this.showNoPeakTime(this.feeRule.highStartTime1,'highEndTime1');
                                        this.showNoPeakTime(this.feeRule.highEndTime2,'highStartTime1',true);

                                }else if(highStartTime1Id === 0 && highEndTime2Id === 48){

                                        this.showNoPeakTime(this.feeRule.highEndTime1,'highStartTime1');
                                        this.showNoPeakTime(this.feeRule.highStartTime2,'highEndTime1',true);
                                }else{

                                        this.showNoPeakTime(this.feeRule.highEndTime1,'highStartTime1');
                                        this.showNoPeakTime(this.feeRule.highStartTime2,'highEndTime1');
                                        this.showNoPeakTime(this.feeRule.highEndTime2,'highStartTime2');
                                        this.showNoPeakTime(this.feeRule.highStartTime1,'highEndTime2');
                                        if(this.activeName == 'first'){
                                                this.feeRule2.useHighTimeStage2 = true;
                                        }
                                        if(this.activeName == 'third'){
                                                this.feeRule4.useHighTimeStage2 = true;
                                        }

                                }
                        }

                },
                // 高峰时间段二开始时间变化
                changeHighStartTime2(){
                        this.feeRule.highEndTime2 = '';
                        let workEndTimes2 = [];
                        let highStartTime1Id = 0;
                        let highStartTime2Id = 0;
                        this.workStartTimes.forEach(ele=>{
                                if(ele.time ==  this.feeRule.highStartTime1){
                                        highStartTime1Id = ele.id;
                                }

                                if(ele.time ==  this.feeRule.highStartTime2){
                                        highStartTime2Id = ele.id;
                                }
                        })
                        if(highStartTime2Id < highStartTime1Id){
                                this.workStartTimes.forEach(ele=>{
                                        if(highStartTime2Id < ele.id  &&  ele.id <= highStartTime1Id){
                                                workEndTimes2.push({
                                                        id:ele.id,
                                                        time:ele.time,
                                                        disabled:false,
                                                })

                                        }
                                })
                        }else{
                                this.workStartTimes.forEach(ele=>{
                                        if(highStartTime2Id < ele.id){
                                                workEndTimes2.push({
                                                        id:ele.id,
                                                        time:ele.time,
                                                        disabled:false,
                                                })

                                        }
                                })
                        }
                        this.workEndTimes2 = workEndTimes2;
                },
                // 選擇高峰時間段二
                selectUseHighTimeStage2(e){
                        if(!this.feeRule.useHighTimeStage2){
                                this.changeHighEndTime1(this.feeRule.highEndTime1);
                                return;
                        }
                        if(!this.feeRule.highStartTime1 || !this.feeRule.highEndTime1){
                                this.$message({
                                        message: '请先设置完【高峰时间段1】',
                                        type: 'warning'
                                });
                                this.feeRule.useHighTimeStage2 = false;
                                return;
                        }
                        let workStartTimes2 = [];
                        let highStartTime1Id = 0;
                        let highEndTime1Id = 0;
                        this.workStartTimes.forEach(ele=>{
                                if(ele.time ==  this.feeRule.highStartTime1){
                                        highStartTime1Id = ele.id;
                                }
                                if(ele.time ==  this.feeRule.highEndTime1){
                                        highEndTime1Id = ele.id;
                                }
                        })
                        this.workStartTimes.forEach(ele=>{
                               if(highStartTime1Id <= ele.id  &&  ele.id < highEndTime1Id){
                                        // workStartTimes2.push({
                                        //         id:ele.id,
                                        //         time:ele.time,
                                        //         disabled:true,
                                        // })
                               }else{
                                        workStartTimes2.push({
                                                id:ele.id,
                                                time:ele.time,
                                                disabled:false,
                                        })
                               }

                        })
                        this.workStartTimes2 = workStartTimes2;

                },
                // 选择收费模式 1 按停车时间收费 2 按次收费
                checkFeeByParkingTime(type){
                        if(type==2){
                                // 打开按次收费一阶段
                                this.feeRule.useCountStage1 = true;
                                // 关闭按停车时间收费相关
                                this.feeRule.useTimeStage1 = false;
                                this.feeRule.useTimeStage2 = false;
                                this.feeRule.useTimeStage3 = false;
                        }else{
                                // 打开按停车时间收费一阶段
                                this.feeRule.useTimeStage1 = true;
                                // 关闭按次收费相关
                                this.feeRule.useCountStage1 = false
                                this.feeRule.useCountStage2 = false;
                        }
                        this.$forceUpdate();


                },
                // 初始化时间选择器
                initTime(){
                        let timeAmount = 24 * 2; //半个小时为单位 一天24小时
                        for(var i = 0;i <= timeAmount; i++){
                                let time = "";
                                let hour = parseInt(i/2);
                                if(hour<10){
                                        hour = '0' + String(hour);
                                }
                                if(i%2==0){
                                        time = hour + ':00'
                                }else{
                                        time = hour + ':30'
                                }
                                this.workStartTimes.push({
                                        id:i,
                                        time:time,
                                        disabled:false,
                                })
                        }

                },
                // 表单验证是否可以切换页签并且判断是否满足条件可以提交
                validateFormJumpAndSubmitFlag(form,callback){
                        let tabName = ''
                        if(form.activeName=='first'){
                                tabName = '工作日高峰'
                        }else if(form.activeName=='second'){
                                tabName = '工作日非高峰'
                        }else if(form.activeName=='third'){
                                tabName = '非工作日高峰'
                        }else if(form.activeName=='fourth'){
                                tabName = '非工作日非高峰'
                        }
                        if(!form.highStartTime1 || !form.highEndTime1){
                                this.$message({
                                        message: `请先设置完【${tabName}】【高峰时间段1】再进行其他操作!`,
                                        type: 'warning'
                                });
                                this.$nextTick(() => {
                                        this.activeName = form.activeName;
                                });

                                return {valid:false,formData:{}};
                        }
                        if(form.useHighTimeStage2 && (!form.highStartTime2 || !form.highStartTime2)){
                                this.$message({
                                        message: `请先设置完【${tabName}】【高峰时间段2】再进行其他操作!`,
                                        type: 'warning'
                                });
                                this.$nextTick(() => {
                                        this.activeName = form.activeName;
                                });
                                return {valid:false,formData:{}};
                        }
                        this.$refs.feeType6Form.validate((valid) => {
                                if(valid){
                                        callback()
                                }else{
                                        this.$message({
                                                message: `请先设置完【${tabName}】相关配置，再进行其他操作!`,
                                                type: 'warning'
                                        });
                                        this.$nextTick(() => {
                                                this.activeName = form.activeName;
                                        });
                                }
                        })
                },
                // 切换页签
                handleTabsClick(tab, event) {
                        if(tab.name=='first'){
                                this.validateFormJumpAndSubmitFlag(this.feeRule,()=>{
                                        this.feeRule = this.feeRule1;
                                })

                        }else if(tab.name=='second'){
                                this.validateFormJumpAndSubmitFlag(this.feeRule,()=>{
                                        this.feeRule = this.feeRule2;
                                })
                        }else if(tab.name=='third'){
                                this.validateFormJumpAndSubmitFlag(this.feeRule,()=>{
                                        this.feeRule = this.feeRule3;
                                })
                        }else if(tab.name=='fourth'){
                                this.validateFormJumpAndSubmitFlag(this.feeRule,()=>{
                                        this.feeRule = this.feeRule4;
                                })
                        }
                        this.$nextTick(() => {
                                this.$refs["feeType6Form"].clearValidate();
                        });

                },
        }
}
</script>